import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../context/ThemeContext';
import './Sponsors.css';

// Placeholder data for sponsors - in a real implementation, this would come from an API
const dummySponsors = [
  {
    id: 1,
    name: 'Mesto Rožňava',
    logo: 'roznava', // Changed to string identifier for CSS class usage
    website: 'https://www.roznava.sk/',
    color: '#d31334' // Brand color
  }
  // {
  //   id: 2,
  //   name: 'Manduka',
  //   logo: null,
  //   website: 'https://www.manduka.com',
  //   color: '#000000' // Brand color
  // },
  // {
  //   id: 3,
  //   name: 'Gaiam',
  //   logo: null,
  //   website: 'https://www.gaiam.com',
  //   color: '#7f3f98' // Brand color
  // },
  // {
  //   id: 4,
  //   name: 'YogaAlliance',
  //   logo: null,
  //   website: 'https://www.yogaalliance.org',
  //   color: '#6a9e32' // Brand color
  // },
  // {
  //   id: 5,
  //   name: 'Liforme',
  //   logo: null,
  //   website: 'https://www.liforme.com',
  //   color: '#5da1dc' // Brand color
  // }
];

const Sponsors = () => {
  const { t } = useTranslation();
  const { currentTheme, themes } = useTheme();
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // In a real implementation, this would fetch sponsors from an API
    // For now, we'll just simulate a loading delay with the dummy data
    const timer = setTimeout(() => {
      setSponsors(dummySponsors);
      setLoading(false);
    }, 300); // Reduced from 500ms

    // Load Cormorant Garamond font
    if (!document.querySelector('link[href*="fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600;700"]')) {
      const garamondLink = document.createElement('link');
      garamondLink.rel = 'stylesheet';
      garamondLink.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600;700&display=swap';
      document.head.appendChild(garamondLink);
    }

    return () => clearTimeout(timer);
  }, []);

  // Function to get initials for a company name
  const getInitials = (name) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase();
  };

  if (loading) {
    return (
      <section className="sponsors-section">
        <div className="container">
          <div className="loading-spinner">{t('loader.loading')}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="sponsors-section">
      <div className="container">
        <h2 className="sponsors-heading">{t('sponsors.our_sponsors')}</h2>
        <p className="sponsors-subheading">{t('sponsors.thanks_to_sponsors')}</p>
        
        <div className="sponsors-container">
          {sponsors.map(sponsor => (
            <a 
              key={sponsor.id} 
              href={sponsor.website} 
              target="_blank" 
              rel="noopener noreferrer"
              className="sponsor-item"
              aria-label={`${sponsor.name} - ${t('sponsors.visit_website')}`}
            >
              <div className="sponsor-logo-container">
                {sponsor.logo === 'roznava' ? (
                  <div className="sponsor-logo-roznava"></div>
                ) : sponsor.logo ? (
                  <img 
                    src={sponsor.logo} 
                    alt={`${sponsor.name} logo`} 
                    className="sponsor-logo"
                    onError={(e) => {
                      // Fallback to text if image fails to load
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                ) : (
                  <div 
                    className="sponsor-name-fallback" 
                    style={{ 
                      display: 'flex',
                      backgroundColor: sponsor.color || 'rgba(var(--primary-color-rgb), 0.1)',
                      color: sponsor.color ? '#ffffff' : 'var(--primary-color)'
                    }}
                  >
                    {getInitials(sponsor.name)}
                  </div>
                )}
              </div>
              <div className="sponsor-name">
                {sponsor.name}
              </div>
            </a>
          ))}
        </div>
        
        <div className="decorative-leaf sponsors-left-leaf"></div>
        <div className="decorative-leaf sponsors-right-leaf"></div>
      </div>
    </section>
  );
};

export default Sponsors; 